import { ApiBase } from '@/api/methods/ApiBase'

export namespace TemporaryUsersApi {
  /**
   * 仮ユーザ削除API
   *
   * @param userId ユーザID
   */
  export async function deleteUser(userId: number): Promise<void> {
    await ApiBase.post(`/manage/temporary/${userId}/delete`)
  }

  /**
   * 仮ユーザパスワード更新API
   *
   * @param userId ユーザID
   * @param newPassword 新しいパスワード
   */
  export async function updateUserPassword(userId: number, newPassword: string): Promise<void> {
    const params = {
      newPassword: newPassword,
    }
    await ApiBase.post(`/manage/temporary/${userId}/password/update`, params)
  }
}
